<script setup>
// Thin wrapper around saas-core's RegisterForm. Same redirect contract as
// Login.vue — emit('success') triggers a router push to either the
// `?redirect=...` target or `/`. The router guards then decide whether
// the new user lands in the admin SPA (platform admins) or gets bounced
// back to the voice client (everyone else, including new personal-tenant
// signups).
import { useRouter, useRoute } from "vue-router";
import RegisterForm from "@digitalstreams/saas-core/vue/views/RegisterForm.vue";

const router = useRouter();
const route = useRoute();

function onSuccess() {
  const target = typeof route.query.redirect === "string" ? route.query.redirect : "/";
  router.push(target);
}
</script>

<template>
  <RegisterForm app-name="i-Recall" @success="onSuccess" />
</template>
